export type AcademicYearListType = {
  value: string;
  label: string;
  isDefault?: boolean;
};

const academicYears: AcademicYearListType[] = [
  { value: '2023-2024', label: '2023-2024' },
  { value: '2024-2025', label: '2024-2025' },
  { value: '2025-2026', label: '2025-2026' },
  { value: '2026-2027', label: '2026-2027', isDefault: true },
  { value: '2027-2028', label: '2027-2028' }
];

const defaultAcademicYear =
  academicYears.find((academicYear) => academicYear.isDefault)?.value ||
  academicYears[0].value;

export { academicYears, defaultAcademicYear };
